import axios from 'axios'

// 字典缓存
const dictCache = {
  data: {},
  timestamp: {},
  // 缓存有效期（毫秒）
  expireTime: 30 * 60 * 1000, // 30分钟
}

// 获取字典数据
export async function getDictItems(dictCode) {
  const now = Date.now()
  
  // 检查缓存是否存在且未过期
  if (dictCache.data[dictCode] && 
      dictCache.timestamp[dictCode] && 
      now - dictCache.timestamp[dictCode] < dictCache.expireTime) {
    return dictCache.data[dictCode]
  }
  
  try {
    // 获取字典项
    const response = await axios.get(`https://aidata.haimoney.com.au/api/dict_item.php?dict_code=${dictCode}`)
    const items = response.data
    
    // 更新缓存
    dictCache.data[dictCode] = items
    dictCache.timestamp[dictCode] = now
    
    return items
  } catch (error) {
    console.error(`获取字典数据失败: ${dictCode}`, error)
    throw error
  }
}

// 获取所有字典数据
export async function getAllDicts() {
  try {
    // 获取所有字典
    const response = await axios.get('https://aidata.haimoney.com.au/api/dict.php')
    const dictList = response.data
    
    // 并行获取所有字典项
    const promises = dictList.map(dict => {
      return axios.get(`https://aidata.haimoney.com.au/api/dict_item.php?dict_code=${dict.code}`)
        .then(response => {
          dictCache.data[dict.code] = response.data
          dictCache.timestamp[dict.code] = Date.now()
          return response.data
        })
    })
    
    await Promise.all(promises)
    return dictCache.data
  } catch (error) {
    console.error('获取字典数据失败:', error)
    throw error
  }
}

// 获取单个字典数据（带缓存）
export function getDict(dictCode) {
  return dictCache.data[dictCode] || []
}

// 清除缓存
export function clearDictCache(dictCode) {
  if (dictCode) {
    delete dictCache.data[dictCode]
    delete dictCache.timestamp[dictCode]
  } else {
    dictCache.data = {}
    dictCache.timestamp = {}
  }
}

// 获取字典名称
export function getDictName(dictCode, code, dictData) {
  if (!code || !dictData || !dictData[dictCode]) return '暂无'
  const item = dictData[dictCode].find(item => item.code === code)
  return item ? item.name : code
} 